import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store';
import { IThunkApi } from '../timesheet/timesheetSlice';
import fetchTimeliveAPI from '../../common/fetchTimeliveAPI';
import fetchAPI from '../../common/fetchAPI';
import { UpdateAccountEmployeeDashboardId } from '../../common/GlobalSlice';


interface DefaultDashboardState {
    status: 'idle' | 'loading' | 'failed';
    isLoading: boolean;
    dashboardsList: any;
    dashboardWidgetDetails: any;
    widgetsResponseById: {
        [key: number]: {
            loading: boolean;
            data: any;
            error: string | null;
        };
    };
    systemWidgets: [];
    layout: any[];
    isReload: boolean;
    EmployeeDashboardId: number;
    refreshFalg: boolean;
    startDate: string;
    endDate: string;
    filterData: any;
    isFilterLoading: boolean;
    IsList: boolean;
    IsAdd: boolean;
    IsDelete: boolean;
    IsEdit: boolean;
    loadedFilterWidgetId: any;
    expenseYear: string;
}


const initialState: DefaultDashboardState = {
    status: 'idle',
    isLoading: false,
    dashboardsList: {},
    dashboardWidgetDetails: null,
    widgetsResponseById: {},
    systemWidgets: [],
    layout: [],
    isReload: false,
    EmployeeDashboardId: 0,
    refreshFalg: false,
    startDate: new Date("2025-01-01").toISOString(),
    endDate: new Date("2026-12-31").toISOString(),
    filterData: [],
    isFilterLoading: false,
    IsList: false,
    IsAdd: false,
    IsEdit: false,
    IsDelete: false,
    loadedFilterWidgetId: null,
    expenseYear: '2026'
};

export const getOrCreateDashboardAction = createAsyncThunk
<any, void, IThunkApi>
(
    'defaultDashboard/GetOrCreateDefaultDashboard',
    async (arg, thunkApi) => {
        const response = await fetchTimeliveAPI(`api/AccountDefaultDashboard/GetOrCreateDefaultDashboard`,'GET','',true);
        const json = await response.json();
        thunkApi.dispatch(
            UpdateAccountEmployeeDashboardId(
                json.Data[0].AccountEmployeeDashboardsId
            )
        );
        return json;
    }
);

export const getDefaultDashboardWidgetDetailsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'defaultDashboard/GetDefaultDashboardWidgetDetails',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/AccountDefaultDashboard/GetDefaultDashboardWidgetDetails/${arg}`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    );

export const getWidgetDataAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'defaultDashboard/GetWidgetData',
        async (arg, thunkApi) => {
            const filterQuery = arg?.filterJson ? encodeURIComponent(arg.filterJson) : '';
            const response = await fetchTimeliveAPI(`api/AccountDefaultDashboard/GetWidgetData/${arg.AccountEmployeeDashboardDetailId}?filtersJson=${filterQuery}`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    );

export const getAccountEmployeeDashboardsAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'defaultDashboard/GetAccountEmployeeDashboards',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/AccountDefaultDashboard/GetAccountEmployeeDashboards`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    );


export const getSystemDashboardWidgetsAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'defaultDashboard/GetSystemDashboardWidgetsAsync',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/AccountDefaultDashboard/GetSystemDashboardWidgets`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    );



export const updateDashboardLayoutAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'defaultDashboard/UpdateDashboardLayout',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/AccountDefaultDashboard/UpdateDashboardLayout`, 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    );

export const addOrUpdateDashboardAsync = createAsyncThunk
    <any, any, IThunkApi>(
        'defaultDashboard/AddOrUpdateDashboard',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/AccountDefaultDashboard/AddOrUpdateDashboard`, 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    );

export const addDashboardWidgetAsync = createAsyncThunk
    <any, any, IThunkApi>(
        'defaultDashboard/AddDashboardWidget',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/AccountDefaultDashboard/AddDashboardWidget`, 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    );


export const deleteAccountEmployeeDashboardAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'defaultDashboard/DeleteAccountEmployeeDashboard',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI('api/AccountDefaultDashboard/DeleteAccountEmployeeDashboard/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountEmployeeDashboardWidgetAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'defaultDashboard/DeleteAccountEmployeeDashboardWidget',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI('api/AccountDefaultDashboard/DeleteAccountEmployeeDashboardWidget/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const GetWidgetFilters = createAsyncThunk
    <any, any, IThunkApi>
    (
        'AccountDefaultDashboard/GetWidgetFilters',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/AccountDefaultDashboard/GetWidgetFilters/${arg}`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    );
export const getPagePermissions = createAsyncThunk
    <any, any, IThunkApi>
    (
        "PagePermission/v2/getPagePermissions",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PagePermission/PagePermissions/' + arg, 'GET', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const renameWidgetAsync = createAsyncThunk<any, any, IThunkApi>(
    "dashboard/UpdateDashboardWidget",
    async (arg, thunkApi) => {
        const response = await fetchTimeliveAPI(`api/AccountDefaultDashboard/UpdateDashboardWidget`, `POST`, arg, true);
        const json = await response.json();
    }
);

export const updateEmployeeOpenNewTabAction = createAsyncThunk<any, any, IThunkApi>(
    'accountEmployee/UpdateEmployeeOpenNewTab',
    async (arg, thunkApi) => {
        try {
            console.log('updateEmployeeOpenNewTabAction', arg)
            const response = await fetchTimeliveAPI(`api/AccountDefaultDashboard/UpdateEmployeeOpenNewTab`, 'PUT',arg, true);
            const json = await response.json();
            return json;
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }    
);


export const defaultDashboardSlice = createSlice({
    name: 'defaultDashboard',
    initialState,
    reducers: {
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateAccountEmployeeDashboardId: (state, action: PayloadAction<any>) => {
            state.EmployeeDashboardId = action.payload;
        },
        updateRefreshState: (state, action) => {
            state.refreshFalg = action.payload
        },
        setDateRangeValue: (state, action) => {
            const { startDate, endDate } = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
        clearDashboardWidgets: (state) => {
            state.dashboardWidgetDetails = null;
            state.widgetsResponseById = {};
        },
        removeWidgetLocally: (state, action) => {
            state.dashboardWidgetDetails = state.dashboardWidgetDetails.filter(
                (w: any) => w.AccountEmployeeDashboardDetailId !== action.payload
            );
        },
          updateYearFilter: (state, action) => {
            state.expenseYear = action.payload
        },
    },
    extraReducers: (builder) => {
        builder

         .addCase(getOrCreateDashboardAction.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getOrCreateDashboardAction.fulfilled, (state, { payload }) => {
                state.status = 'idle';              
                state.isLoading = false;
            })
            .addCase(getOrCreateDashboardAction.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getDefaultDashboardWidgetDetailsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getDefaultDashboardWidgetDetailsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.dashboardWidgetDetails = payload.Data;
                state.isLoading = false;
            })
            .addCase(getDefaultDashboardWidgetDetailsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(getWidgetDataAsync.pending, (state, action) => {
                // state.status = 'loading';
                // state.isLoading = true;
                const id = action.meta.arg.AccountEmployeeDashboardDetailId;
                state.widgetsResponseById[id] = {
                    loading: true,
                    data: [],
                    error: null
                };
            })
            .addCase(getWidgetDataAsync.fulfilled, (state, action) => {
                // state.status = 'idle';
                // state.isLoading = false;
                // const id = action.meta.arg.AccountEmployeeDashboardDetailId;

                // state.widgetsResponseById[id] = {
                //     loading: false,
                //     data: action.payload,
                //     error: null
                // };
                const id = action.meta.arg.AccountEmployeeDashboardDetailId;
                state.widgetsResponseById[id] = {
                    loading: false,
                    data: action.payload,
                    error: null
                };
            })
            .addCase(getWidgetDataAsync.rejected, (state, action) => {
                const id = action.meta.arg.AccountEmployeeDashboardDetailId;
                state.widgetsResponseById[id] = {
                    loading: false,
                    data: [],
                    error: "Error"
                };
                // state.status = 'failed';
                // state.isLoading = false;
            })


            .addCase(getAccountEmployeeDashboardsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })

            .addCase(getAccountEmployeeDashboardsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.dashboardsList = payload.Data;
                state.isReload = false;

            })

            .addCase(getAccountEmployeeDashboardsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })


            .addCase(getSystemDashboardWidgetsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })

            .addCase(getSystemDashboardWidgetsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.systemWidgets = payload.Data;
                state.isReload = false;

            })

            .addCase(getSystemDashboardWidgetsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(updateDashboardLayoutAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateDashboardLayoutAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(updateDashboardLayoutAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(addOrUpdateDashboardAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addOrUpdateDashboardAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(addOrUpdateDashboardAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addDashboardWidgetAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addDashboardWidgetAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                // state.isReload = true;
            })
            .addCase(addDashboardWidgetAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountEmployeeDashboardAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountEmployeeDashboardAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;
                state.isLoading = false;
            })
            .addCase(deleteAccountEmployeeDashboardAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountEmployeeDashboardWidgetAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountEmployeeDashboardWidgetAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;
                state.isLoading = false;
            })
            .addCase(deleteAccountEmployeeDashboardWidgetAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(GetWidgetFilters.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
                state.isFilterLoading = true;
                state.filterData = [];
                state.loadedFilterWidgetId = null;
            })
            .addCase(GetWidgetFilters.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isFilterLoading = false;
                state.filterData = action.payload;
                state.loadedFilterWidgetId = action.meta.arg;
            })
            .addCase(GetWidgetFilters.rejected, (state) => {
                state.status = 'failed';
                state.isFilterLoading = false;
            })
            .addCase(getPagePermissions.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getPagePermissions.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                state.IsList = action.payload.IsList;
                state.IsAdd = action.payload.IsAdd;
                state.IsEdit = action.payload.IsEdit;
                state.IsDelete = action.payload.IsDelete;
            })
            .addCase(getPagePermissions.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(renameWidgetAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(renameWidgetAsync.fulfilled, (state) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(renameWidgetAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
             .addCase(updateEmployeeOpenNewTabAction.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateEmployeeOpenNewTabAction.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(updateEmployeeOpenNewTabAction.rejected, (state) => {
                state.status = 'failed';
            })
    }
});

export const { updateIsLoading, updateAccountEmployeeDashboardId, updateRefreshState, setDateRangeValue, clearDashboardWidgets , updateYearFilter} = defaultDashboardSlice.actions
export const defaultDashboardState = (state: RootState) => state.dashboard;
export default defaultDashboardSlice.reducer;